import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
export default {
  name: 'CustomLink',
  props: {
    url: {
      type: String,
      require: true
    },
    target: {
      type: String,
      default: null
    }
  },
  computed: {
    CustomLink: function CustomLink() {
      return 'a';
    }
  },
  methods: {
    linkProps: function linkProps(path) {
      if (path.match(/^(http(s)?:)?\/\//) || this.target) {
        return {
          is: 'a',
          href: path,
          target: this.target
        };
      }
      return {
        is: 'nuxt-link',
        to: path
      };
    }
  }
};